import React from 'react';
import { useDrop } from 'react-dnd';
import TaskRow, { TASK_DRAG_TYPE, type TaskDragItem } from './TaskRow';
import type { PlanTask } from '../../../types/plan';

type BacklogPanelProps = {
  tasks: PlanTask[];
  onDropTask: (taskId: number, date: string | null) => void;
  onToggle: (task: PlanTask) => void;
  onEdit: (task: PlanTask) => void;
};

const BacklogPanel: React.FC<BacklogPanelProps> = ({ tasks, onDropTask, onToggle, onEdit }) => {
  const [{ isOver }, drop] = useDrop<TaskDragItem, unknown, { isOver: boolean }>(
    () => ({
      accept: TASK_DRAG_TYPE,
      drop: (item) => {
        if (item.planned_for !== null) onDropTask(item.id, null);
      },
      collect: (monitor) => ({ isOver: monitor.isOver() }),
    }),
    [onDropTask]
  );

  return (
    <div
      ref={drop as unknown as React.Ref<HTMLDivElement>}
      className={`flex min-h-[240px] flex-col rounded-xl border p-3 transition-colors ${
        isOver ? 'border-blue-400 bg-blue-50/40' : 'border-gray-200 bg-white'
      }`}
    >
      <div className="mb-3 flex items-baseline justify-between">
        <span className="text-base font-semibold text-gray-900">Backlog</span>
        <span className="text-xs text-gray-500">未排期 {tasks.length}</span>
      </div>

      <div className="flex-1">
        {tasks.map((task) => (
          <TaskRow key={task.id} task={task} onToggle={onToggle} onEdit={onEdit} />
        ))}
      </div>

      <div className="mt-2 rounded-lg border border-dashed border-gray-300 py-3 text-center text-xs text-gray-400">
        拖到这里取消排期
      </div>
    </div>
  );
};

export default BacklogPanel;
